<template>
  <div class="container lms-wrapper">
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <div class="card">
          <div class="card-body">
            <!-- @on-create-course="createCourse" -->
            <teacher-nav @route-changed="toggleNavbar(false)" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="lms-content"
      @click="navbarMode == 1 ? toggleNavbar(false) : ''"
    >
      <vue-custom-scrollbar
        class="lms-content-body"
        style="height: calc(100vh - 70px);"
      >
        <user-cover />
        <div class="row mg-t-10 mg-b-30">
          <div
            v-for="(s, si) in stats"
            :key="si"
            class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
          >
            <div class="card">
              <div class="card-body pd-y-15">
                <div class="media">
                  <div
                    :class="
                      `wd-40 wd-md-50 ht-40 ht-md-50 bg-${s.bg} tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6`
                    "
                    style="min-width:40px;"
                  >
                    <feather :type="s.icon"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      {{ s.title }}
                    </h6>
                    <h5
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{ s.value }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-5 col-lg-4 col-xl-4">
            <div class="card">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <div class="tx-14 tx-color-02">Сургалтын төрөл</div>
              </div>
              <div class="card-body" v-if="fetched">
                <apexchart
                  :key="chartKey + '_groupedByShape'"
                  type="donut"
                  :options="{
                    responsive: [
                      {
                        options: {
                          chart: { width: '100%' },
                          legend: {
                            position: 'bottom',
                            width: 400,
                            height: 400
                          }
                        }
                      }
                    ],
                    plotOptions: {
                      pie: { customScale: 1, size: 300, donut: { size: '60%' } }
                    },
                    labels: statData.course.coursesByShape.map(x => {
                      return x.name;
                    })
                  }"
                  :series="
                    statData.course.coursesByShape.map(x => {
                      return x.count;
                    })
                  "
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-7 col-md-7 col-lg-8 col-xl-8">
            <div class="card">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <div class="tx-14 tx-color-02">
                  Сургалтад хамрагдсан
                  {{
                    $store.state.app.activeGroup.id == 9132
                      ? "оюутан"
                      : "ажилтан"
                  }}
                </div>
              </div>
              <div class="card-body" v-if="fetched">
                <apexchart
                  :key="chartKey"
                  type="area"
                  height="250"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="card">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <div class="tx-14 tx-color-02">Хамгийн их үзсэн сургалт</div>
              </div>
              <div class="card-body pd-b-7" v-if="fetched">
                <ul class="list-group text-left">
                  <li
                    v-for="(s, i) in statData.course.mostViewedCourse"
                    :key="i"
                    class="list-group-item d-flex align-items-center mg-b-10 bg-gray-100 bd-0 rounded-10"
                  >
                    <span class="text-muted">{{ i + 1 }}.</span>
                    <div class="mg-l-10">{{ s.name }}</div>
                    <span class="mg-l-auto text-muted tx-11">
                      {{ s.count }}
                      <i class="far fa-eye mg-l-5"></i>
                    </span>
                  </li>
                </ul>
              </div>
              <div class="card-footer text-center tx-13">
                <router-link
                  :to="{ name: 'lmsActivity' }"
                  class="btn btn-light rounded-pill"
                >
                  Дэлгэрэнгүй
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="card">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <div class="tx-14  tx-color-02">
                  Хамгийн олон сургалт хамрагдсан оролцогч
                </div>
              </div>
              <div class="card-body pd-b-0" v-if="fetched">
                <ul class="list-group">
                  <li
                    v-for="(s, i) in statData.user.mostJoined"
                    :key="i"
                    class="list-group-item d-flex align-items-center bd-t-0 bd-l-0 bd-r-0"
                    :class="{
                      'bd-b-0': i == statData.user.mostJoined.length - 1
                    }"
                  >
                    <span class="text-muted">{{ i + 1 }}.</span>
                    <img
                      :src="s.user.avator"
                      class="wd-30 rounded-circle mg-x-10"
                      alt
                    />
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                        {{ s.user.fullName }}
                      </h6>
                      <span class="d-block tx-11 text-muted">{{
                        s.user.position
                      }}</span>
                    </div>
                    <span class="mg-l-auto text-muted tx-11 link-03"
                      >{{ s.count }} удаа</span
                    >
                  </li>
                </ul>
              </div>
              <div class="card-footer text-center tx-13">
                <router-link
                  :to="{ name: 'lmsActivity' }"
                  class="btn btn-light rounded-pill"
                >
                  Дэлгэрэнгүй
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="card">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <div class="tx-14  tx-color-02">
                  Хамгийн их кредит цуглуулсан
                </div>
              </div>
              <div class="card-body pd-b-0" v-if="fetched">
                <ul class="list-group">
                  <li
                    v-for="(s, i) in statData.user.mostCreditEarned"
                    :key="i"
                    class="list-group-item d-flex align-items-center bd-t-0 bd-l-0 bd-r-0"
                    :class="{
                      'bd-b-0': i == statData.user.mostCreditEarned.length - 1
                    }"
                  >
                    <span class="text-muted">{{ i + 1 }}.</span>
                    <img
                      :src="s.user.avator"
                      class="wd-30 rounded-circle mg-x-10"
                      alt
                    />
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                        {{ s.user.fullName }}
                      </h6>
                      <span class="d-block tx-11 text-muted">{{
                        s.user.position
                      }}</span>
                    </div>
                    <span class="mg-l-auto text-muted tx-11 link-03"
                      >{{ s.credit }} Кредит</span
                    >
                  </li>
                </ul>
              </div>
              <div class="card-footer text-center tx-13">
                <router-link
                  :to="{ name: 'lmsActivity' }"
                  class="btn btn-light rounded-pill"
                >
                  Дэлгэрэнгүй
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="card">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <div class="tx-14  tx-color-02">
                  Нийт сургалтад хамрагдсан ажилтнууд
                  <!-- (1800/270) -->
                </div>
              </div>
              <div class="card-body pd-b-0" v-if="fetched">
                <ul class="list-group">
                  <li
                    v-for="(s, i) in statData.user.mostFinished"
                    :key="i"
                    class="list-group-item d-flex align-items-center bd-t-0 bd-l-0 bd-r-0"
                    :class="{
                      'bd-b-0': i == statData.user.mostFinished.length - 1
                    }"
                  >
                    <span class="text-muted">{{ i + 1 }}.</span>
                    <img
                      :src="s.user.avator"
                      class="wd-30 rounded-circle mg-x-10"
                      alt
                    />
                    <div>
                      <h6
                        class="tx-13 tx-inverse tx-semibold mg-b-0 text-truncate"
                      >
                        {{ s.user.fullName }}
                      </h6>
                      <span class="d-block tx-11 text-muted text-truncate">{{
                        s.user.position
                      }}</span>
                    </div>
                    <span class="mg-l-auto text-muted tx-11 link-03"
                      >{{ s.count }} удаа {{ s.credit }} Кредит</span
                    >
                  </li>
                </ul>
              </div>
              <div class="card-footer text-center tx-13">
                <router-link
                  :to="{ name: 'lmsActivity' }"
                  class="btn btn-light rounded-pill"
                >
                  Дэлгэрэнгүй
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>
    <vue-custom-scrollbar
      class="lms-sidebar-right"
      style="height: calc(100vh - 100px);"
    >
      <div class="card">
        <div class="card-body">
          <teacher-calendar />
        </div>
      </div>
    </vue-custom-scrollbar>

    <!-- <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      @on-attach="showFile($event)"
      @on-task-posted="taskPosted"
      @on-edit-close="editClosed"
    ></task-edit>-->
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import VueApexCharts from "vue-apexcharts";

import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
    vueCustomScrollbar,
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teacherNav: () => ({
      component: import("@/views/modules/lms/teacher/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    // taskEdit: () => ({
    //   component: import("@/components/task/edit/base"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    teacherCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      navbarMode: 0,
      // project: {
      //   id: 0,
      //   title: ""
      // },
      // taskEdit: {
      //   id: 0,
      //   show: false,
      //   render: false,
      //   objectTypeId: 0,
      //   projectId: 0
      // },
      stats: [],
      fetched: false,
      statData: {},
      chartKey: 0,
      series: [{ name: "Сургалтад хамрагдсан хэрэглэгч", data: [] }],
      chartOptions: {
        chart: {
          height: 250,
          type: "area"
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },

        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          position: "bottom",
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        }
      }
    };
  },
  mounted() {
    // let prjs = this.$store.state.app.groupDefaultProjects.filter(
    //   x => x.objectTypeId == 115
    // );
    // if (prjs != undefined && prjs.length) {
    //   this.project = prjs[0];
    // }

    this.initStats();

    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    initStats() {
      request({
        api: { method: "get", url: "Learn/AnnualStatFilters" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          request({
            api: { method: "get", url: "Learn/AnnualStatHomeData" },
            params: { year: new Date().getFullYear() },
            store: this.$store
          }).then(res => {
            if (res != false) {
              //console.log(res);
              this.fetched = true;
              //console.log(res.data);
              this.statData = res.data;
              this.chartOptions.xaxis.categories = res.data.course.joinedByMonth.map(
                x => {
                  return x.joinedMonth + "-р сар";
                }
              );
              this.series[0].data = res.data.course.joinedByMonth.map(x => {
                return x.count;
              });
              this.chartKey++;
              this.stats.push({
                id: 1,
                title: "Нийт сургалт",
                value: this.statData.course.allCount,
                icon: "book",
                bg: "purple"
              });
              this.stats.push({
                id: 2,
                title: "Идэвхитэй сургалт",
                value: this.statData.course.active,
                icon: "star",
                bg: "info"
              });
              this.stats.push({
                id: 3,
                title: "Сургалтад хамрагдсан цаг",
                value: "0 цаг",
                icon: "clock",
                bg: "success"
              });
            }
          });
        }
      });
      //console.log('initStats', stat);
    }
    // createCourse(){
    //   this.taskEdit.id = 0;
    //   this.taskEdit.objectTypeId = 115;
    //   this.taskEdit.projectId = this.project.id;
    //   this.taskEdit.render = true;
    //   this.$nextTick(function() {
    //     this.taskEdit.show = true;
    //   });
    // },
    // taskPosted(e){
    // console.log(e);
    // },
    // editClosed(){
    //   this.taskEdit.show = false;
    //   this.taskEdit.id = 0;
    // },
  }
};
</script>

<style></style>
